<template>
  <div id="network-setup">
    <v-card style="margin-top: 20px" id="network-card">
      <v-card-title>
        <span class="main_card_title">{{ $i18n.t('pages.network.network_settings.title') }}</span>
      </v-card-title>

      <v-card-text>
        <div style="width: 400px; padding: 0 15px 0">
          <div class="network-card-elements">
            <v-radio-group
              style="margin: 0 !important;"
              :label="$i18n.t('pages.network.network_settings.mode') + ': '"
              v-model="network_settings.mode"
              row
            >
              <v-radio
                v-for="mode in network_modes"
                :key="mode.value"
                :value="mode.value"
                :label="`${mode.text}`"
              />
            </v-radio-group>
            <v-text-field
                outlined
                class="rounded_8px"
                :label="$i18n.t('pages.network.network_settings.mac_address')"
                v-model="mac_address"
                readonly
                placeholder="00:00:00:00:00:00"
                disabled
            />
            <v-select
                outlined
                class="rounded_8px"
                :label="$i18n.t('pages.network.network_settings.ip_version')"
                :items="ip_versions"
                v-model="network_settings.ip_version"
                :disabled="network_settings.mode === 'dhcp'"
            />
            <v-text-field
                outlined
                class="rounded_8px"
                :label="$i18n.t('pages.network.network_settings.ip_address')"
                v-model="network_settings.ip_address"
                placeholder="255.255.255.0"
                :disabled="network_settings.mode === 'dhcp'"
            />
            <v-text-field
                outlined
                class="rounded_8px"
                :label="$i18n.t('pages.network.network_settings.netmask')"
                v-model="network_settings.netmask"
                placeholder="255.255.255.0"
                :disabled="network_settings.mode === 'dhcp'"
            />
            <v-text-field
                outlined
                class="rounded_8px"
                :label="$i18n.t('pages.network.network_settings.gateway')"
                v-model="network_settings.gateway"
                placeholder="255.255.255.0"
                :disabled="network_settings.mode === 'dhcp'"
            />
            <v-text-field
                class="rounded_8px"
                outlined
                label="DNS 1"
                v-model="network_settings.dns_1"
                placeholder="8.8.8.8"
                :disabled="network_settings.mode === 'dhcp'"
            />
            <v-text-field
                class="rounded_8px"
                outlined
                label="DNS 2"
                v-model="network_settings.dns_2"
                placeholder="8.8.8.8"
                :disabled="network_settings.mode === 'dhcp'"
            />
          </div>
          <div class="spaced-between">
            <v-btn
                class="width48 white--text"
                height="42"
                color="#DBEAF1"
                elevation="0"
                @click="close_editor"
            >
              <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
            </v-btn>
            <v-btn
                class="width48 white--text"
                height="42"
                color="#207ea9"
                elevation="0"
                @click="save_network_settings"
            >
              <span class="button-font">{{ $i18n.t('general.save') }}</span>
            </v-btn>
          </div>
        </div>
      </v-card-text>

      <!--
      <v-card-text>
        <v-btn
            elevation="0"
            height="42px"
            width="300px"
            @click="open_network_editor"
            v-on="on" v-bind="attrs"
            color="#207ea9" class="white--text"
            style="margin-bottom: 15px"
        >
          <span class="button-font">{{ $i18n.t('pages.network.network_settings.change_network_settings') }}</span>
        </v-btn>
        <v-dialog eager max-width="400" v-model="network_edit_dialog">
          <v-card style="border-radius: 8px" elevation="0">
            <v-card-title>
              {{ $i18n.t('pages.network.network_settings.change_network_settings') }}
            </v-card-title>
            <v-card-text style="padding: 0 15px 30px">
              <div class="network-card-elements">
                <v-radio-group
                  :label="$i18n.t('pages.network.network_settings.mode') + ': '"
                  v-model="network_settings.mode"
                  row
                >
                  <v-radio
                    v-for="mode in network_modes"
                    :key="mode.value"
                    :value="mode.value"
                    :label="`${mode.text}`"
                  />
                </v-radio-group>
                <v-text-field
                    outlined
                    class="rounded_8px"
                    :label="$i18n.t('pages.network.network_settings.mac_address')"
                    v-model="mac_address"
                    readonly
                    placeholder="00:00:00:00:00:00"
                    disabled
                />
                <v-select
                    outlined
                    class="rounded_8px"
                    :label="$i18n.t('pages.network.network_settings.ip_version')"
                    :items="ip_versions"
                    v-model="network_settings.ip_version"
                    :disabled="network_settings.mode === 'dhcp'"
                />
                <v-text-field
                    outlined
                    class="rounded_8px"
                    :label="$i18n.t('pages.network.network_settings.ip_address')"
                    v-model="network_settings.ip_address"
                    placeholder="255.255.255.0"
                    :disabled="network_settings.mode === 'dhcp'"
                />
                <v-text-field
                    outlined
                    class="rounded_8px"
                    :label="$i18n.t('pages.network.network_settings.netmask')"
                    v-model="network_settings.netmask"
                    placeholder="255.255.255.0"
                    :disabled="network_settings.mode === 'dhcp'"
                />
                <v-text-field
                    outlined
                    class="rounded_8px"
                    :label="$i18n.t('pages.network.network_settings.gateway')"
                    v-model="network_settings.gateway"
                    placeholder="255.255.255.0"
                    :disabled="network_settings.mode === 'dhcp'"
                />
                <v-text-field
                    class="rounded_8px"
                    outlined
                    label="DNS 1"
                    v-model="network_settings.dns_1"
                    placeholder="8.8.8.8"
                    :disabled="network_settings.mode === 'dhcp'"
                />
                <v-text-field
                    class="rounded_8px"
                    outlined
                    label="DNS 2"
                    v-model="network_settings.dns_2"
                    placeholder="8.8.8.8"
                    :disabled="network_settings.mode === 'dhcp'"
                />
              </div>
              <div class="spaced-between">
                <v-btn
                    class="width48 white--text"
                    height="42"
                    color="#DBEAF1"
                    elevation="0"
                    @click="close_editor"
                >
                  <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
                </v-btn>
                <v-btn
                    class="width48 white--text"
                    height="42"
                    color="#207ea9"
                    elevation="0"
                    @click="save_network_settings"
                >
                  <span class="button-font">{{ $i18n.t('general.save') }}</span>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-text>
      -->
    </v-card>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import {i18n} from "@/i18n";

export default {
  name: "NetworkSetup",
  props: ['on', 'attrs'],
  data: function () {
    this.fetch_data()
    return {
      network_edit_dialog: false,
      network_modes: [ {text: i18n.t('pages.network.network_settings.static'), value: 'static'}, {text: 'DHCP', value: 'dhcp'}],
      ip_versions: [{text: 'IPv4', value: 'inet'}, {text: 'IPv6', value: 'inet6'}],
      network_settings: {
        mode: '',
        ip_version: '',
        ip_address: '',
        netmask: '',
        gateway: '',
        dns_1: '',
        dns_2: ''
      },
      mac_address: ''
    }
  },
  methods: {
    fetch_data: function () {
      this.$http({url: this.$http_hostname + '/network_settings', method: 'GET'})
      .then(resp => {
        this.network_settings.mode = resp.data.mode
        this.network_settings.ip_version = resp.data.ip_version
        this.network_settings.ip_address = resp.data.address
        this.network_settings.netmask = resp.data.netmask
        this.network_settings.gateway = resp.data.gateway
        this.mac_address = resp.data.mac_address
        this.network_settings.dns_1 = resp.data.dns_nameservers ? resp.data.dns_nameservers[0] : null
        this.network_settings.dns_2 = resp.data.dns_nameservers ? resp.data.dns_nameservers[1] : null
      })
      .catch(() => {
        this.setSnackbar({
          text: i18n.t('notifications.error_during_data_loading'),
        })
      })
    },
    open_network_editor: function () {
      this.network_edit_dialog = true
    },
    close_editor: function () {
      this.network_edit_dialog = false
    },
    save_network_settings: function () {
      let data = this.network_settings
      this.updateLoadingOverlay({is_loading: true})
      this.$http({url: this.$http_hostname + '/network_settings', data: data, method: 'POST'})
      .then(() => {
        this.setSnackbar({
          text: i18n.t('notifications.network.network_settings_changed'),
        })
        this.updateLoadingOverlay({is_loading: false})
      })
      .catch(error => {
        console.log(error)
        if (error.message == 'Network Error' && window.hostname !== 'localhost' && this.$ws_hostname === null) {
          window.location.href = `http://${this.network_settings.ip_address}/${this.$i18n.locale}/network_settings`;
        } else {
          this.setSnackbar({
            text: i18n.t('notifications.network.error_during_changing_network_settings')
          })
        }
      })
      this.network_edit_dialog = false
    },
  ...mapActions(['setSnackbar', 'updateLoadingOverlay'])
  },
  computed: {
    ...mapGetters(['loadingOverlay', 'systemParams'])
  }

}
</script>

<style scoped>
#network-card {
  background: #FFFFFF;
  box-shadow: 0 3px 2px rgba(138, 138, 138, 0.15);
  border-radius: 8px;
}
.network-card-elements {
  display: flex;
  flex-direction: column;
  margin: 0 15px;
}
.spaced-between {
  display: flex;
  justify-content: space-between;
  margin: 0 15px;
}
.width48 {
  /*margin: 0 3% 10px 0; */
  width: 48%;
}

</style>